var s = (t, r, e) => new Promise((c, p) => {
  var a = (o) => {
    try {
      n(e.next(o));
    } catch (i) {
      p(i);
    }
  }, f = (o) => {
    try {
      n(e.throw(o));
    } catch (i) {
      p(i);
    }
  }, n = (o) => o.done ? c(o.value) : Promise.resolve(o.value).then(a, f);
  n((e = e.apply(t, r)).next());
});
import { selfAxios as l } from "@oppein/op-utils";
function u(t) {
  return s(this, null, function* () {
    const {
      data: r
    } = yield l.post(
      "/designordercenter/productionOrder/specialApply/createColorProofing",
      t
    );
    return r == null ? void 0 : r.data;
  });
}
export {
  u as postCreateColorProofing
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designordercenter/productionOrder/specialApply/createColorProofing/post.js
// module id = 1776
// module chunks = 41